export const LEAD_SOURCES = {
  CUSTOM: '1',
  NIMBATA: '2',
  FORM: '3',
};

export const LEADS_STATUS = {
  0: 'Pages with no client',
  1: 'Pages with client',
};

export const LEAD_STATUSES = {
  NEW: 'new',
  IN_PROGRESS: 'in_progress',
  QUOTE: 'quote',
  DEAL: 'deal',
  NO_DEAL: 'no_deal',
  ARCHIVED: 'archived',
};

// AI Analysis Types
export const AI_ANALYSIS_TYPES = {
  QUOTE_SENT: 'quote_sent',
  QUOTE_ACCEPTED: 'quote_accepted',
  PRICE_MENTIONED: 'price_mentioned',
  NEGOTIATION: 'negotiation',
  REJECTION: 'rejection',
};

// AI Analysis Status
export const AI_ANALYSIS_STATUS = {
  PENDING: 'pending',
  SUGGESTED: 'suggested',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  AUTO_APPLIED: 'auto_applied',
};

// AI Analysis Type Labels (Swedish)
export const AI_ANALYSIS_TYPE_LABELS = {
  [AI_ANALYSIS_TYPES.QUOTE_SENT]: 'Offert skickad',
  [AI_ANALYSIS_TYPES.QUOTE_ACCEPTED]: 'Offert godkänd',
  [AI_ANALYSIS_TYPES.PRICE_MENTIONED]: 'Pris nämnt',
  [AI_ANALYSIS_TYPES.NEGOTIATION]: 'Förhandling',
  [AI_ANALYSIS_TYPES.REJECTION]: 'Avslag',
};

// AI Analysis Status Labels (Swedish)
export const AI_ANALYSIS_STATUS_LABELS = {
  [AI_ANALYSIS_STATUS.PENDING]: 'Väntar',
  [AI_ANALYSIS_STATUS.SUGGESTED]: 'Förslag',
  [AI_ANALYSIS_STATUS.ACCEPTED]: 'Accepterad',
  [AI_ANALYSIS_STATUS.REJECTED]: 'Avvisad',
  [AI_ANALYSIS_STATUS.AUTO_APPLIED]: 'Auto-applicerad',
};

// AI Confidence Thresholds
export const AI_CONFIDENCE_THRESHOLDS = {
  HIGH: 0.90, // Auto-apply threshold
  MEDIUM: 0.70,
  LOW: 0.50,
};

// Maps AI analysis types to suggested lead status changes
export const AI_STATUS_MAPPING = {
  [AI_ANALYSIS_TYPES.QUOTE_SENT]: LEAD_STATUSES.QUOTE,
  [AI_ANALYSIS_TYPES.QUOTE_ACCEPTED]: LEAD_STATUSES.DEAL,
};
